import * as React from "react";
const SvgMidCentury = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16.72 2.54a.75.75 0 0 1-.51.93l-.21.061v6.965h5.25a.75.75 0 0 1 .75.75v9a1.75 1.75 0 0 1-1.75 1.75h-3.175A.767.767 0 0 1 17 22h-3.5a.765.765 0 0 1-.074-.003H10.5a1.385 1.385 0 0 1-.1.003H6.6c-.034 0-.068-.001-.1-.003H4.25a1.75 1.75 0 0 1-1.75-1.75V7.459l-.041.011a.75.75 0 0 1-.42-1.44l13.75-4a.75.75 0 0 1 .93.51Zm-6.477 17.956A1.65 1.65 0 0 0 8.6 19h-.2a1.65 1.65 0 0 0-1.643 1.497h3.486Zm1.504 0h1.003V15.75a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 .75.75v4.747h2.5a.25.25 0 0 0 .25-.25v-8.25h-5.175a.775.775 0 0 1-.15 0H9.75v5.72a3.152 3.152 0 0 1 1.997 2.78ZM8.25 17.505v-5.508H4v8.25c0 .139.112.25.25.25h1.004a3.15 3.15 0 0 1 2.996-2.992ZM9.75 5.35v5.146h4.75V3.968L9.75 5.35ZM4 7.022v3.474h4.25v-4.71L4 7.022ZM16.25 16.5h-2v3.997h2V16.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMidCentury;
